<template>
  <div>
    <div class="row">
      <div class="col-md-12 text-center">
        <h4 class="purple">Date despre trimitere</h4>
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
            <div class="dataCampaign">
                <p><span>{{$t('marketingCampaigns.sent')}}: </span><span>{{model.sent}}</span></p>
                <p><span>{{$t('marketingCampaigns.notif_sent')}}: </span><span>{{model.notif_sent}}</span></p>
                <p><span>{{$t('marketingCampaigns.email_sent')}}: </span><span>{{model.email_sent}}</span></p>
            </div>
            <div class="statusBar">
              <div class="barr" :style="{ width: calcWidthProc(model.in_queue, model.total_notificatios_to_be_sent) + '%' }"></div>
              <span>{{model.total_notificatios_to_be_sent - model.in_queue}} {{$t('marketingCampaigns.off')}} {{model.total_notificatios_to_be_sent}} - {{calcWidthProc(model.in_queue, model.total_notificatios_to_be_sent)}}%</span>
            </div>
          </div>
        </div>
        <br>
        <br>
      </div>
      <div>
        <h4 class="purple text-center">{{$t('marketingPromos.send')}}</h4>
        <div class="row">
          <div class="col-md-6 col-md-offset-1">
            <div class="form-group">
              <p-checkbox
                class="margin-left-10"
                v-model="model.type_email"
                key="type_email"
                :label="$t('marketingPromos.email')"
                :inline="true"
                @input="validate"
                name="Email">{{$t('marketingPromos.email')}}
              </p-checkbox>
              <p-checkbox
                v-model="model.type_push"
                key="type_push"
                :label="$t('campaignsNotificationTypes.PUSH')"
                :inline="true"
                @input="validate"
                name="Push Notification">{{$t('campaignsNotificationTypes.PUSH')}}
              </p-checkbox>
            </div>
            <small class="text-danger" v-if="!model.type_push && !model.type_email">
              {{ $t('validations.requiredField') }}
            </small>
          </div>
          <div class="col-md-1 inline-auto pad-rg-0">
            <div class="form-group">
              <label class="control-label inline">{{$t('marketingCampaigns.mode')}}</label>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <select v-model="model.mode"
                        name="mode"
                        :placeholder="$t('marketingCampaigns.mode')"
                        v-validate="modelValidations.mode"
                        class="form-control notof-mode">
                <option selected="" disabled="" value=""> - {{$t('general.select')}} - </option>
                <option v-for="(type, key) in campaignsModes"
                          :value="key">{{$t('campaignsModes.' + key)}}</option>
              </select>
              <small class="text-danger" v-if="errors.has('mode')">
                {{ $t('validations.requiredField') }}
              </small>
            </div>
          </div>
          <div class="col-md-10 col-md-offset-1" v-if="model.mode == 'AUTO'">
            <div class="form-group">
              <label>{{$t('marketingCampaigns.setHours')}}</label>
              <hr class="sm mar-to-0 mar-bt-0">
              <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-12 padd" v-for="day in daysOfWeek" :key="day.key">
                  <p-checkbox
                    v-model="model[day.key + '_active']"
                    :key="day.key"
                    class="text-purple"
                    @input="setDefaultHour($event, day.key)"
                    :label="$t('days.' + day.key)">{{ $t('days.' + day.key) | capitalize }}
                  </p-checkbox>

                  <el-time-select
                    :disabled="!model[day.key + '_active']"
                    :editable="false"
                    :placeholder="$t('marketingCampaigns.selectTime')"
                    v-model="model[day.key]"
                    v-validate="modelValidations.time"
                    :picker-options="pickerOptions">
                  </el-time-select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 text-center">
        <h4 class="purple">{{$t('marketingCampaigns.campaignDetails')}}</h4>
      </div>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.name')}}*</label>
          <input type="text"
                 name="name"
                 :placeholder="$t('marketingCampaigns.name')"
                 v-validate="modelValidations.name"
                 v-model="model.name"
                 class="form-control">
          <span class="text-muted">{{ $t('marketingCampaigns.nameHelper') }}</span>
          <div>
            <small class="text-danger" v-if="errors.has('name')">
              {{ getError('name') }}
            </small>
          </div>

        </div>
      </div>
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.image')}}</label>
          <el-upload
            action=""
            ref="upload"
            :limit="2"
            :file-list="model.imagelist"
            list-type="picture-card"
            accept=" .jpg, .jpeg, .png"
            :on-change="handleImgChnage"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :auto-upload="false">
            <i class="el-icon-plus"></i>
            <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
          </el-upload>
        </div>
      </div>

      <div class="col-md-5 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.validFromTo')}}*</label>
          <br/>
          <el-date-picker type="daterange" v-model="model.fromto"
                              name="dateRange"
                              v-validate="modelValidations.dateRange"
                              :picker-options="pickerOptions1">
          </el-date-picker>
        </div>
        <small class="text-danger" v-if="errors.has('dateRange')">
          {{ $t('validations.requiredField') }}
        </small>
      </div>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h4 class="purple text-center">{{$t('marketingCampaigns.notif_sent')}}</h4>
          <label>{{$t('marketingCampaigns.description')}} <small>{{$t('marketingCampaigns.maxDescription')}}</small>*</label>
          <textarea name="description" rows="6"
                  :placeholder="$t('marketingCampaigns.description')"
                  v-model="model.description"
                  v-validate="modelValidations.description"
                  class="form-control"></textarea>
          <div>
          <small class="pull-right">{{model.description ? model.description.length : '0'}} {{$t('marketingCampaigns.characters')}}</small></div>
          <small class="text-danger" v-if="errors.has('description')">
            {{ getError('description') }}
          </small>
        </div>
      </div>

      <div class="col-md-2 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingOffers.linkType')}}</label>
          <select class="form-control" v-model="model.link_type" @change="getLocations()">
            <option disabled>- {{$t('general.select')}} -</option>
            <option :value="1">{{$t('marketingCampaigns.intern')}}</option>
            <option :value="2">{{$t('marketingCampaigns.extern')}}</option>
          </select>
          <small class="text-danger" v-if="errors.has('link_type')">
            {{ getError('link_type') }}
          </small>
        </div>
      </div>
      <div v-if="model.link_type === 2" class="col-md-8">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.url')}}</label>
          <input class="form-control" v-model="model.url" placeholder="https://www.google.ro/"/>
          <small class="text-danger" v-if="errors.has('url')">
            {{ getError('url') }}
          </small>
        </div>
      </div>
      <div v-if="model.link_type === 1" class="col-md-2">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.location')}}</label>
          <select class="form-control" v-model="model.location_token" @input="validate" @change="getCategories()">
            <option disabled>- {{$t('general.select')}} -</option>
            <option v-for="loc in locations" :key="loc.token" :value="loc.token">{{ loc.name }}</option>
          </select>
          <small class="text-danger" v-if="errors.has('location_token')">
            {{ getError('location_token') }}
          </small>
        </div>
      </div>
      <div v-if="model.link_type === 1" class="col-md-3">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.category')}}</label>
          <select class="form-control" v-model="model.category_id"  @change="getProducts()" :disabled="!model.location_token">
            <option :value="null">- {{$t('general.select')}} -</option>
            <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.label }}</option>
          </select>
          <small class="text-danger" v-if="errors.has('category_id')">
            {{ getError('category_id') }}
          </small>
        </div>
      </div>
      <div v-if="model.link_type === 1" class="col-md-3">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.product')}}</label>
          <select class="form-control" v-model="model.product_id" :disabled="!model.category_id">
            <option :value="null">- {{$t('general.select')}} -</option>
            <option v-for="prod in products" :key="prod.id" :value="prod.id">{{ prod.name }}</option>
          </select>
          <small class="text-danger" v-if="errors.has('product_id')">
            {{ getError('product_id') }}
          </small>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <p-checkbox
            class="margin-left-10"
            v-model="model.ignore_email_template"
            label="Foloseste textul notificare pentru email"
            :inline="true">{{$t('marketingCampaigns.useEmailTemplate')}}
          </p-checkbox>
        </div>
      </div>

      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <h4 class="purple text-center">{{$t('marketingPromos.email')}}</h4>
          <div class="email-builder">
            <EmailEditor v-on:load="editorLoaded" minHeight="700px" ref="emailEditor" />
          </div>
          <div class="row">
            <div class="col-md-3">
              <button
                style="display: none"
                class="btn btn-purple mar-to-10 mar-bt-10 generate-code"
                @click.prevent="exportHtml()"
              >Export</button>
              <button
                class="btn btn-purple mar-to-10 mar-bt-10 generate-code"
                @click.prevent="loadTemplate('template1')"
              >{{$t('marketingCampaigns.template')}} 1</button>
              <button
                class="btn btn-purple mar-to-10 mar-bt-10 generate-code"
                @click.prevent="loadTemplate('template2')"
              >{{$t('marketingCampaigns.template')}} 2</button>
              <!-- <button
                class="btn btn-purple mar-to-10 mar-bt-10 generate-code"
                @click.prevent="saveDesign()"
              >Save</button> -->
              <!-- <button
                class="btn btn-purple mar-to-10 mar-bt-10 generate-code"
                @click.prevent="emptyBuilder()"
              >Empty</button> -->
            </div>
          </div>
        </div>
      </div>
      <upload-image-modal
        ref="modal"
        :handleModal="modalState"
      >
      </upload-image-modal>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  import { EmailEditor } from 'vue-email-editor'
  import Vue from 'vue'
  import template from '../template.json'
  import template2 from '../template2.json'
  import UploadImageModal from '../UploadImageModal.vue'
  Vue.use(EmailEditor)

  export default {
    components: {
      EmailEditor,
      UploadImageModal
    },
    props: {
      modelFromParent: {
        type: [Object, Array],
        required: true
      },
      daysParent: {
        type: Array,
        required: true
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.model = value
        // Pass your template JSON here
        if (this.model.email_json && this.$refs.emailEditor.editor) {
          this.$refs.emailEditor.editor.loadDesign(this.model.email_json)
        } else if (this.$refs.emailEditor.editor) {
          this.$refs.emailEditor.editor.loadDesign(template)
        }
        this.editorLoaded()
      },
      daysParent (value, oldVal) {
        this.days = value
      },
      // pentru fiecare zi
      'model.monday' (val) {
        if (val && !this.model.monday_active) this.model.monday_active = 1
      },
      'model.tuesday' (val) {
        if (val && !this.model.tuesday_active) this.model.tuesday_active = 1
      },
      'model.wednesday' (val) {
        if (val && !this.model.wednesday_active) this.model.wednesday_active = 1
      },
      'model.thursday' (val) {
        if (val && !this.model.thursday_active) this.model.thursday_active = 1
      },
      'model.friday' (val) {
        if (val && !this.model.friday_active) this.model.friday_active = 1
      },
      'model.saturday' (val) {
        if (val && !this.model.saturday_active) this.model.saturday_active = 1
      },
      'model.sunday' (val) {
        if (val && !this.model.sunday_active) this.model.sunday_active = 1
      }
    },
    computed: {
      ...mapFields(['name']),
      ...mapFields(['notification_types', 'notification_mode', 'email'])
    },
    data () {
      return {
        date: {
          trends: {
            'valid': [
              '2018-01-01',
              '2018-12-31'
            ]
          }
        },
        model: this.value || this.modelFromParent,
        days: this.value || this.daysParent,
        modalState: false,
        locations: [],
        categories: [],
        products: [],
        daysOfWeek: [
          { key: 'monday' },
          { key: 'tuesday' },
          { key: 'wednesday' },
          { key: 'thursday' },
          { key: 'friday' },
          { key: 'saturday' },
          { key: 'sunday' }
        ],
        modelValidations: {
          name: {
            required: true
          },
          description: {
            max: 400,
            required: true
          },
          notification_type: {
            required: true
          },
          notification_mode: {
            required: true
          },
          mode: {
            required: true
          },
          time: {
            required: true
          },
          image: {
            required: true
          },
          dateRange: {
            required: true
          }
        },
        couponType: this.$session.get('defaultData')['coupons_types'],
        couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
        pickerOptions1: {},
        pickerNames: ['date_from', 'date_to'],
        desclength: 0,
        pickerOptions: {
          start: '08:00',
          step: '01:00',
          end: '24:00'
        },
        campaignsNotificationTypes: [], // this.$session.get('defaultData')['campaigns_notification_types'],
        campaignsModes: []// this.$session.get('defaultData')['campaigns_modes']
      }
    },
    created () {
      // console.warn(this.$session.get('defaultData')['campaigns_notification_types'])
      this.campaignsNotificationTypes = this.$session.get('defaultData')['campaigns_notification_types']
      this.campaignsModes = this.$session.get('defaultData')['campaigns_modes']
      this.getLocations()
      this.getCategories()
      this.$nextTick(() => {
        if (!this.$route.params.id) {
          this.$refs.emailEditor.editor.loadDesign(template)
        }
        this.model.mode = 'MANUAL'
      })
    },
    methods: {
      getLocations () {
        if (!this.model.location_token) {
          let requestData = {
            token: this.$session.get('token'),
            company_id: this.$session.get('selectedCompany')
          }
          this.apiRequest('/get-locations', 'GET', requestData, (response) => {
            if (response.status) {
              this.locations = response.data
            }
          })
        }
      },
      getCategories () {
        if (this.model.link_type === 1 && !this.model.location_token) {
          this.model.category_id = null
        }
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/get-categories', 'GET', requestData, (response) => {
          if (response.status) {
            this.categories = response.data
            this.getProducts()
          }
        })
      },
      getProducts () {
        if (this.model.link_type === 1 && !this.model.category_id) {
          this.model.product_id = null
        }
        let requestData = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          category_id: this.model.category_id,
          location_token: this.model.location_token
        }
        this.apiRequest('/get-products', 'GET', requestData, (response) => {
          if (response.status) {
            this.products = response.data
          }
        })
      },
      setDefaultHour ($event, day) {
        if ($event) {
          Vue.set(this.model, day + '_active', 1)
          if (!this.model[day]) {
            Vue.set(this.model, day, this.pickerOptions.start)
          }
        } else {
          Vue.set(this.model, day + '_active', 0)
          Vue.set(this.model, day, null)
        }
      },
      editorLoaded () {
        this.$refs.emailEditor.editor.addEventListener('design:updated', (updates) => {
          this.$refs.emailEditor.editor.exportHtml((data) => {
            if (data) {
              this.model.email_html = data.html
              this.model.email_json = data.design
            }
          })
        })
        this.$refs.emailEditor.editor.registerCallback('selectImage', (data, done) => {
          // Open your image library
          // Once a user picks an image, call the done function with URL
          this.handleUpload().then(result => {
            if (result) {
              done({ url: result })
            }
          })
        })
      },
      saveDesign () {
        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            this.model.email_html = JSON.stringify(data.html)
            this.model.email_json = JSON.stringify(data.design)
            let requestData = {}
            var id = this.$route.params.id || this.couponErrorCampaignId
            if (this.model.imagelist === 0) {
              this.model.image_url = ''
            }
            if (Object.keys(this.model.imagelist).length && this.model.imagelist[0].status === 'ready' && this.$route.params.id) {
              this.getBase64(this.model.imagelist[0].raw).then(
                (base64enc) => {
                  requestData.id = id
                  requestData.token = this.$session.get('token')
                  requestData.company_id = this.model.company_id
                  requestData.image = base64enc
                  requestData.name = this.model.name
                  requestData.type = this.model.type
                  requestData.mode = this.model.mode
                  requestData.email_html = JSON.stringify(data.html)
                  requestData.email_json = JSON.stringify(data.design)
                  this.apiRequest('/campaign/' + id, 'PUT', requestData, (response) => {
                    if (response.status === true) {
                      swal(
                        {
                          title: '',
                          text: 'Campaign Updated',
                          type: 'success',
                          showConfirmButton: false,
                          timer: 1500
                        }
                      )
                    } else {
                      swal(
                        {
                          title: '',
                          text: 'Failed to update the campaign',
                          type: 'error',
                          showConfirmButton: false,
                          timer: 1500
                        }
                      ) // end swal
                    }
                  }) // end api response
                }
              ) // end getBase64.then
            }
          }
        )
      },
      exportHtml () {
        this.$refs.emailEditor.editor.exportHtml(
          (data) => {
            // console.log(JSON.stringify(data.design))
          }
        )
      },
      loadTemplate (templateName) {
        let templateData = null
        if (templateName === 'template1') {
          templateData = template
        }
        if (templateName === 'template2') {
          templateData = template2
        }
        if (templateData) {
          this.$refs.emailEditor.editor.loadDesign(templateData)
        }
      },
      showModal () {
        return new Promise((resolve, reject) => {
          this.$refs.modal.open()
          this.$refs.modal.$once('selected-image', (url) => {
            resolve(url)
          })
          this.$refs.modal.$once('close', () => {
            reject(new Error('Modal closed without submitting.'))
          })
        })
      },
      async handleUpload () {
        try {
          const result = await this.showModal()
          return result // Do something with the result
        } catch (error) {
          console.error(error)
        }
      },
      // emptyBuilder () {
      //   this.$refs.emailEditor.editor.loadDesign(templateEmpty)
      // },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        if (this.model.link_type === 1 && this.model.location_token === null) {
          this.errors.add('location_token', 'Location is required.')
        } else {
          if (this.errors.items.length) {
            this.errors.items.splice(this.errors.items.indexOf({'field': 'location_token', 'msg': 'Location is required.'}), 1)
          }
        }
        return this.$validator.validateAll()
        // this.$validator.validateAll().then(isValid => {
        //   // this.$emit('on-submit', this.registerForm, isValid)
        //   return isValid
        // })
      },
      handleImgChnage (file, fileList) {
        // console.warn('handleImgChnage')
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('validations.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      },
      calcWidthProc (toBeSent, total) {
        let sent = total - toBeSent
        if (!sent) {
          sent = 0
        }
        let pr = (sent / total)
        if (!pr) {
          pr = 0
        }
        let rez = (pr * 100).toFixed(0)
        if (rez < 0) {
          rez = 0
        }
        if (rez > 100) {
          rez = 100
        }
        return rez
      }
    }
  }
</script>
<style>
  .el-upload--picture-card{
    width: 148px;
    height: 148px;
    line-height: 146px;
  }
  .email-builder {
    display: flex;
    flex-direction: column;
    position: relative;
    height: 700px;
  }
  .margin-left-10 {
    margin-left: 10px;
  }
  .dataCampaign {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .dataCampaign p {
    font-size: 12px;
  }

  .statusBar {
    width: 100%;
    height: 20px;
    border: 1px solid #000;
    background: #fff;
    position: relative;
  }
  .statusBar .barr {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: #5e35b1;
    opacity: 0.5;
  }
  .statusBar span {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    height: 100%;
    z-index: 2;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/FirstStep.vue